"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationError = void 0;
var ValidationError = /** @class */function (_super) {
  __extends(ValidationError, _super);
  function ValidationError(failure) {
    var _this = _super.call(this, failure.message) || this;
    _this.name = 'ValidationError';
    _this.code = failure.code;
    if (failure.details !== undefined) _this.details = failure.details;
    Object.setPrototypeOf(_this, ValidationError.prototype);
    return _this;
  }
  return ValidationError;
}(Error);
exports.ValidationError = ValidationError;